import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaPaw } from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="srtech-contact-section">


      <h1 className="srtech-contact-title">Get in Touch</h1>

      <div className="srtech-contact-container">
           {/* Phone Card */}
           <div className="srtech-contact-card">
          <FaPhoneAlt className="srtech-contact-icon" />
          <h2 className="srtech-card-title">Call Us</h2>
          <p className="srtech-card-text">
            +91 6304692989 <br /> +91 9160383791
          </p>
        </div>
        {/* Address Card */}
        <div className="srtech-contact-card">
          <FaMapMarkerAlt className="srtech-contact-icon" />
          <h2 className="srtech-card-title">Our Address</h2>
          <p className="srtech-card-text">
            41-30/1-49, Krishna Lanka, Vijayawada, Pin: 520013
          </p>
        </div>

        {/* Email Card */}
        <div className="srtech-contact-card">
          <FaEnvelope className="srtech-contact-icon" />
          <h2 className="srtech-card-title">Email Us</h2>
          <p className="srtech-card-text-email">petburialvijayawada@gmail.com</p>
        </div>

     
      </div>

      {/* About Us Section */}
      <div className="srtech-about-container">
        <FaPaw className="srtech-about-icon" />
        <h2 className="srtech-about-title">About Us</h2>
        <p className="srtech-about-text">
          We provide compassionate pet cremation and burial services, ensuring a dignified farewell for your beloved companions.
        </p>
      </div>
    </div>
  );
};

export default Contact;
